import script from "./TicketDetailItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./TicketDetailItem.vue?vue&type=script&setup=true&lang=ts"

import "./TicketDetailItem.vue?vue&type=style&index=0&id=3203cf7b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3203cf7b"]])

export default __exports__